import { getData, postData } from "../utils";

export async function updateCommit(
  selectedNetwork,
  commitStr,
  blockNumber,
  transactionHash
) {
  try {
    const response = await postData("/api/v1/update_commit", {
      chainId: selectedNetwork.chainIdDec,
      commitStr,
      blockNumber,
      transactionHash,
    });
    return response.data;
  } catch (err) {
    return Promise.reject(err);
  }
}

export async function getTransactions(modulo, address) {
  try {    
    let url = "/api/v1/get_history";
    if (modulo) {
      url = `${url}?modulo=${modulo}`;
    }
    if (address) {
      url = `${url}${modulo ? "&" : "?"}address=${address}`;
    }
    const response = await getData(url);
    return response.data.transactions;
  } catch (err) {
    return Promise.reject(err);
  }
}
